export default __webpack_public_path__ + "cd0147fa072087f1335997bc510bcb6f.svg";